export const TRAFFIC_CONGESTION = "TRAFFIC_CONGESTION";
export const VIOLATIONS = "VIOLATIONS";
export const TOTAL_VIOLATIONS = "TOTAL_VIOLATIONS";
export const TURN_VIOLATIONS = "TURN_VIOLATIONS";
export const RECENT_VIOLATIONS_EVENT = "RECENT_VIOLATIONS_EVENT";




// WEBPACK FOOTER //
// ./src/config/componentKeys.ts